<template>
    <div class="voucher-consume mt-2">
        <div v-if="displayCurrentVoucher">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p v-for="entry in voucherInfo">
                            <strong>{{ entry.label }}</strong>
                            <span :class="entry.className || ''" v-if="typeof entry.value === 'string'">{{ entry.value }}</span>
                            <span :class="entry.className || ''" v-if="typeof entry.value === 'object'">
                                <br/>
                                <span v-for="value in entry.value">{{ value }}<br/>
                                </span>
                            </span>
                        </p>
                        <div v-if="currentVoucher.formInputs">
                            <p>
                                <a data-toggle="collapse" style="cursor: pointer"
                                   data-target="#collapseExample" aria-expanded="false"
                                   aria-controls="collapseExample">
                                    Informações dos consumidores:

                                </a>
                            </p>
                            <div class="collapse" id="collapseExample">
                                <div v-for="tariff in currentVoucher.tariffs" :key="tariff.id">
                                    <div v-for="quantity in tariff.quantity" :key="quantity">
                                        <p><strong>Tarifa {{ quantity }} - {{ tariff.type_name }}:</strong></p>
                                        <p v-for="input in currentVoucher.formInputs"
                                           :key="input.id"
                                           style="margin-left: 10px"
                                           v-if="input.id_sale_tariff == tariff.id && input.number == quantity"
                                        >
                                            <strong>{{ input.name }}:</strong>
                                            <span>{{ input.value }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="saleHasOpenRefundRequest">
                            <div class="alert alert-warning" role="alert">
                                <strong>Atenção:</strong> A venda deste voucher possui uma solicitação de estorno em processamento.
                            </div>
                        </div>

                        <p v-if="this.hiddenSaleLink === '0'">
                            <a :href="currentVoucher.sale.url" target="_blank">Ver venda</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="displayOptions">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 mb-2" v-if="browserSupportsUserMedia">
                        <button class="btn btn-primary btn-block btn-large" v-on:click="switchToQrMode">Com QR Code</button>
                    </div>
                    <div class="col-md-4" v-if="canConsume">
                        <button class="btn btn-primary btn-block btn-large" v-on:click="switchToCodeMode">Com código e senha</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="displayQrReader">
            <div class="container">
                <div class="row">
                    <div class="col-md-4">
                        <video ref="videoDisplay" class="video-display" autoplay playsinline></video>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 offset-md-1">
                        <button type="button" class="btn btn-secondary btn-block btn-large" v-on:click="switchToIndex">Voltar</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="displayConfirmation">
            <div class="container">
                <div v-if="errorMsg" class="row">
                    <div class="col-md-4">
                        <strong class="error-message">{{ errorMsg }}</strong>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 col-6">
                        <button type="button" class="btn btn-secondary btn-block btn-large" v-on:click="switchToPreviousConsumptionMode">Voltar</button>
                    </div>
                    <div v-if="currentVoucherCanBeConsumed" class="col-md-2 col-6">
                        <button type="button" class="btn btn-primary btn-block btn-large" v-on:click="handleConsumeClick(false, qrCodeData.secret)">Consumir</button>
                    </div>
                    <div v-if="displayConsumeAllButton" class="col-md-2 col-6">
                        <button type="button" class="btn btn-success btn-block btn-large" v-on:click="handleConsumeAllClick(false, qrCodeData.secret)">Consumir Todos</button>
                    </div>
                </div>
            </div>
        </div>
        <form v-else-if="displayCodeForm" v-on:submit.prevent="handleCodeSubmit">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 form-group">
                        <input v-model="codeValue" type="text" class="form-control" placeholder="Código" required />
                    </div>
                </div>
                <div v-if="errorMsg" class="row">
                    <div class="col-md-4">
                        <strong class="error-message">{{ errorMsg }}</strong>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 col-6">
                        <button type="button" class="btn btn-secondary btn-block btn-large" v-on:click="switchToIndex">Voltar</button>
                    </div>
                    <div class="col-md-2 col-6">
                        <button type="submit" class="btn btn-primary btn-block btn-large">Pesquisar</button>
                    </div>
                </div>
            </div>
        </form>
        <form v-else-if="displaySecretForm" v-on:submit.prevent="handleConsumeClick(false, secretValue)">
            <div class="container">
                <div v-if="currentVoucherCanBeConsumed" class="row">
                    <div class="col-md-4 form-group">
                        <input v-model="secretValue" type="text" class="form-control" placeholder="Senha" required />
                    </div>
                </div>
                <div v-if="errorMsg" class="row">
                    <div class="col-md-4">
                        <strong class="error-message">{{ errorMsg }}</strong>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 col-6">
                        <button type="button" class="btn btn-secondary btn-block btn-large" v-on:click="switchToCodeMode">Voltar</button>
                    </div>
                    <div v-if="currentVoucherCanBeConsumed" class="col-md-2 col-6">
                        <button type="submit" class="btn btn-primary btn-block btn-large">Consumir</button>
                    </div>
                    <div v-if="displayConsumeAllButton" class="col-md-3 col-6">
                        <button type="button" class="btn btn-success btn-block btn-large" v-on:click="handleConsumeAllClick(false, secretValue)">Consumir Todos</button>
                    </div>
                    <div class="col-12" style="margin-top: 10px" v-if="currentVoucher.exceptionally_consumed_at == null && canConsumeExceptionally">
                        <small>Caso não possua o voucher, clique <a v-on:click="handleConsumeClick(true)" class="underline"><strong style="cursor: pointer">aqui</strong></a> para realizar o consumo de forma excepcional.</small>
                    </div>
                </div>
            </div>
        </form>
        <div v-else-if="displayResultNotice">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 text-center">
                        <div class="check-circle">
                            <i :class="'material-icons ' + statusIcon ">{{statusIcon}}</i>
                        </div>
                        <p>{{statusMsg}}</p>
                    </div>
                </div>
                <div class="row">
                    <div v-if="displayResultBackButton" class="col-md-2 col-12 mb-1">
                        <button type="button" class="btn btn-secondary btn-block btn-large" v-on:click="switchToCorrectConsumptionMode">Voltar</button>
                    </div>
                    <div class="col-md-2 offset-md-1 col-12">
                        <button type="button" class="btn btn-primary btn-block btn-large" v-on:click="switchToPreviousConsumptionMode">Ler novo voucher</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jsQR from 'jsqr';
import { requestJson, formatCents } from '../helpers';
import mixpanel from 'mixpanel-browser';

const INDEX = 'index';
const CODE = 'code';
const SECRET = 'secret';
const RESULT = 'result';
const QR = 'qr';
const CONFIRMATION = 'confirmation';

// Copied from widget code
const sliceN = num => `00${num}`.slice(-2);
const formatDateTime = str => {
    const d = new Date(str);
    const dateStr = [sliceN(d.getDate()), sliceN(d.getMonth() + 1), d.getFullYear()].join('/');
    const timeStr = [d.getHours(), d.getMinutes()].map(sliceN).join(':');

    return `${dateStr} ${timeStr}`;
};

export default {
    props: {
        voucherSearchUrl: String,
        hiddenSaleLink: String,
        mixpanelToken: String,
        appEnv: String,
        canConsumeExceptionally: Boolean,
        canConsume: Boolean,
        canConsumeAll: Boolean,
    },
    data(){
        return {
            mode: INDEX,
            codeValue: '',
            secretValue: '',
            errorMsg: null,
            currentVoucher: null,
            videoStream: null,
            scanAttemptId: null,
            qrCodeData: null,
            selectedConsumptionMode: null,
            statusIcon: null,
            statusMsg: null,
            timeoutRef: null,
            globalQrCodeBuffer: '',
            globalKeyboardListener: null,
        };
    },
    computed: {
        displayOptions(){
            return this.mode === INDEX;
        },
        displayQrReader(){
            return this.mode === QR;
        },
        displayConfirmation(){
            return this.mode === CONFIRMATION;
        },
        displayCodeForm(){
            return this.mode === CODE;
        },
        displaySecretForm(){
            return this.mode === SECRET;
        },
        displayResultNotice(){
            return this.mode === RESULT;
        },
        displayCurrentVoucher(){
            return [CONFIRMATION, SECRET].includes(this.mode);
        },
        displayResultBackButton(){
            return this.statusIcon !== 'check_circle' && this.currentVoucher !== null;
        },

        voucherInfo(){
            const { currentVoucher: voucher } = this;
            if(voucher == null) {
                return null;
            }

            if (voucher.revoked_at) {
                return [{ value: 'Voucher cancelado!', className: 'text-danger font-weight-bold' }];
            }

            const arr = [
                { label: 'Código:', value: voucher.code },
                { label: 'Cliente:', value: voucher.customer },
                { label: 'Horário:', value: voucher.formatted_schedule },
            ];

            if (voucher.resources) {
                arr.push({ label: 'Lugares:', value: voucher.resources.join(', ') });
            }

            arr.push({ label: 'Tarifas:', value: voucher.tariffs.map(t => `${t.type_name} (${t.quantity}) - ${formatCents(t.value_cents)}`) });

            if (voucher.product) {
                arr.push({ label: 'Produto:', value: voucher.product });
            }

            if (voucher.reservation_info) {
                const { total_vouchers, consumed_vouchers, has_other_consumable_vouchers } = voucher.reservation_info;
                arr.push({
                    label: 'Vouchers da reserva:',
                    value: `${consumed_vouchers}/${total_vouchers} consumidos ${has_other_consumable_vouchers ? ` (${total_vouchers - consumed_vouchers} pendentes)` : ''}`,
                });
            }

            if (voucher.consumed_at || voucher.exceptionally_consumed_at) {
                const useExceptional = voucher.exceptionally_consumed_at && voucher.consumed_at == null;
                arr.push({
                    label: useExceptional ? 'Consumido de forma excepcional em:' : 'Consumido em:',
                    value: formatDateTime(useExceptional ? voucher.exceptionally_consumed_at : voucher.consumed_at),
                    className: 'text-success font-weight-bold',
                });
            }

            if (voucher.proposalName) {
                arr.push({ label: '', value: '----------------' });
                arr.push({ label: 'Programa:', value: voucher.proposalName });
            }
            if (voucher.agentName) {
                arr.push({ label: 'Agente:', value: voucher.agentName });
            }

            return arr;
        },
        currentVoucherCanBeConsumed(){
            return this.voucherCanBeConsumed(this.currentVoucher);
        },
        browserSupportsUserMedia(){
            return 'mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices;
        },
        saleHasOpenRefundRequest(){
            return this.currentVoucher.sale.openRefundRequestsCount > 0;
        },
        displayConsumeAllButton(){
            return this.currentVoucherCanBeConsumed && this.currentVoucher.reservation_info && this.currentVoucher.reservation_info.has_other_consumable_vouchers && this.canConsumeAll;
        },
    },
    mounted() {
        this.mixPanelInit();
    },
    beforeDestroy() {
        // Clean up global keyboard listener
        this.removeGlobalKeyboardListener();
    },

    methods: {
        shouldSendTelemetry() {
            const env = (this.appEnv || '').toLowerCase();
            return env !== 'local' && !!this.mixpanelToken;
        },
        mixPanelInit() {
            if (!this.shouldSendTelemetry()) {
                return;
            }

            mixpanel.init(this.mixpanelToken);
            
        },
        mixpanelTrack(event, payload = {}) {
            if (!this.shouldSendTelemetry()) {
                return;
            }

            mixpanel.track(event, payload);
            
        },
        setupGlobalKeyboardListener() {
            this.globalKeyboardListener = (event) => {
                // Ignore if user is typing in the qrCodeString input
                if (event.target && event.target.id === 'qrCodeString') {
                    return;
                }
                
                // Capture printable characters
                if (event.key && event.key.length === 1) {
                    this.globalQrCodeBuffer += event.key;
                }
                // Handle Enter key to process the buffer
                else if (event.key === 'Enter') {
                    if (this.globalQrCodeBuffer.trim()) {
                        this.validateAndLoadQrCode();
                        this.globalQrCodeBuffer = '';
                    }
                }
                // Handle Backspace to remove last character
                else if (event.key === 'Backspace') {
                    this.globalQrCodeBuffer = this.globalQrCodeBuffer.slice(0, -1);
                }
            };
            
            document.addEventListener('keydown', this.globalKeyboardListener);
        },
        
        removeGlobalKeyboardListener() {
            if (this.globalKeyboardListener) {
                document.removeEventListener('keydown', this.globalKeyboardListener);
                this.globalKeyboardListener = null;
            }
        },
        
        validateAndLoadQrCode() {
            const qrCodeString = this.globalQrCodeBuffer.trim();
            
            if (!qrCodeString) {
                return;
            }
            
            // Try to parse as JSON
            let jsonData;
            try {
                jsonData = JSON.parse(qrCodeString);
            } catch (err) {
                // Try URL decode first
                try {
                    const decodedData = decodeURIComponent(qrCodeString);
                    jsonData = JSON.parse(decodedData);
                } catch (decodedErr) {
                    // Not valid JSON, ignore
                    return;
                }
            }
            
            // Create a mock QR code object similar to what jsQR returns
            const mockQrCode = {
                data: qrCodeString
            };
            
            // Call loadVoucher with the mock QR code object
            this.loadVoucher(mockQrCode);
        },
        
        switchToIndex(event){
            this.switchMode(INDEX, event);
        },
        switchToCodeMode(event){
            this.switchMode(CODE, event);
        },
        switchToSecretMode(event){
            this.switchMode(SECRET, event);
        },
        switchToResultMode(success, msg, event = null){
            this.statusIcon = success ? 'check_circle' : 'cancel';
            this.statusMsg = msg;

            this.switchMode(RESULT, event);
        },
        switchToQrMode(event){
            this.switchMode(QR, event);
        },
        switchToConfirmationMode(){
            this.switchMode(CONFIRMATION);
        },
        switchToPreviousConsumptionMode(event){
            this.switchMode(this.selectedConsumptionMode ?? INDEX, event);
        },
        switchToCorrectConsumptionMode(event){
            this.switchMode(this.selectedConsumptionMode === QR ? CONFIRMATION : SECRET, event);
        },
        switchMode(mode, event = null){
            if(this.mode === mode){
                return;
            }

            // Blur the button if event is provided
            if (event && event.target) {
                event.target.blur();
            }

            if (this.timeoutRef) {
                clearTimeout(this.timeoutRef);
            }

            switch(this.mode){
                case QR:
                    this.shutdownQrReading();
                    break;
            }

            this.mode = mode;

            switch(this.mode){
                case INDEX:
                    this.selectedConsumptionMode = null;
                    this.currentVoucher = null;
                    this.qrCodeData = null;
                    this.globalQrCodeBuffer = '';
                    this.errorMsg = null;
                    break;
                case CODE:
                    this.selectedConsumptionMode = this.mode;
                    this.currentVoucher = null;
                    this.codeValue = '';
                    this.errorMsg = null;
                    break;
                case SECRET:
                    this.secretValue = '';
                    this.errorMsg = null;
                    break;
                case QR:
                    this.selectedConsumptionMode = this.mode;
                    this.globalQrCodeBuffer = '';
                    this.errorMsg = null;
                    this.setupQrReading();
                    break;
                case CONFIRMATION:
                    this.errorMsg = null;
                    break;
                case RESULT:
                    this.timeoutRef = setTimeout(() => this.switchToPreviousConsumptionMode(), 3000);
                    break;
            }
        },

        async setupQrReading(){
            const supported = navigator.mediaDevices.getSupportedConstraints();
            const constraints = {
                video: supported.facingMode ? {
                    facingMode: { ideal: 'environment' }
                } : true,
                audio: false
            };

            let stream;
            try {
                stream = await navigator.mediaDevices.getUserMedia(constraints);
            } catch(err) {
                alert('Erro ao obter vídeo!');
                return;
            }

            this.handleVideoStream(stream);
            this.setupGlobalKeyboardListener();
        },
        handleVideoStream(stream){
            this.videoStream = stream;

            const el = this.$refs.videoDisplay;
            el.srcObject = stream;

            this.attemptScan(el);
        },
        attemptScan(video){
            const ok = this.readQrCode(video);

            if (!ok) {
                this.scanAttemptId = setTimeout(() => this.attemptScan(video), 250);
            }
        },
        readQrCode(video){
            const { videoWidth, videoHeight } = video;
            if(!videoWidth || !videoHeight){
                return false;
            }

            const width = 320;
            const height = Math.round(videoHeight * width / videoWidth);

            const el = document.createElement('canvas');
            el.width = width;
            el.height = height;

            const ctxt = el.getContext('2d');
            ctxt.drawImage(video, 0, 0, width, height);

            const { data } = ctxt.getImageData(0, 0, width, height);
            const code = jsQR(data, width, height);

            if(code == null){
                return false;
            }

            this.mixpanelTrack('consume-voucher/qrcode-read', {
                'qrCode': code,
                'qrCodeData': code.data,
            });

            this.loadVoucher(code);

            return true;
        },
        async loadVoucher(qrCode){
            this.errorMsg = null;

            let json;
            try {
                json = JSON.parse(qrCode.data);
                this.mixpanelTrack('consume-voucher/qrcode-parse', {
                    'qrCode': qrCode,
                    'qrCodeData': qrCode.data,
                    'parsedQrCode': json
                });
            } catch(err) {
                // Try URL decode first
                try {
                    const decodedData = decodeURIComponent(qrCode.data);
                    json = JSON.parse(decodedData);
                    this.mixpanelTrack('consume-voucher/qrcode-parse-url-decoded', {
                        'qrCode': qrCode,
                        'qrCodeData': qrCode.data,
                        'decodedData': decodedData,
                        'parsedQrCode': json
                    });
                } catch(decodedErr) {
                    this.mixpanelTrack('consume-voucher/qrcode-parse-error', {
                        'qrCode': qrCode,
                        'qrCodeData': qrCode.data,
                        'err': err,
                        'decodedErr': decodedErr
                    });
                    this.errorMsg = 'QR Code inválido!';
                    return;
                }
            }
            this.qrCodeData = json;

            const { app, code, secret } = this.qrCodeData;
            const arr = await this.searchVouchers({ app, code, secret });

            this.mixpanelTrack('consume-voucher/search-voucher', {
                'qrCode': qrCode,
                'qrCodeData': code.data,
                'response': arr
            });

            if (!arr) {
                this.mixpanelTrack('consume-voucher/search-voucher-not-found', {
                    'qrCode': qrCode,
                    'qrCodeData': code.data,
                    'response': arr
                });
                return this.switchToResultMode(false, 'Erro durante o reconhecimento do voucher.');
            }

            if (arr.error && arr.error === 'invalid_app') {
                this.mixpanelTrack('consume-voucher/search-voucher-invalid-app', {
                    'qrCode': qrCode,
                    'qrCodeData': code.data,
                    'response': arr
                });
                return this.switchToResultMode(false, 'Voucher inválido.');
            }

            if (Array.isArray(arr) && arr.length) {
                const voucher = arr[0];

                if (this.voucherCanBeConsumed(voucher)) {
                    this.currentVoucher = voucher;
                    return this.switchToConfirmationMode();
                } else {
                    this.mixpanelTrack('consume-voucher/search-voucher-invalid-voucher', {
                        'qrCode': qrCode,
                        'qrCodeData': code.data,
                        'voucher': voucher
                    });
                    return this.switchToResultMode(false, 'Atenção! Voucher inválido ou já consumido!');
                }
            }

            this.mixpanelTrack('consume-voucher/search-voucher-unknown-error', {
                'qrCode': qrCode,
                'qrCodeData': code.data,
                'response': arr
            });
            return this.switchToResultMode(false, 'Erro desconhecido.');
        },
        shutdownQrReading(){
            if(!this.videoStream){
                return;
            }

            clearTimeout(this.scanAttemptId);

            this.videoStream.getTracks().forEach(track => track.stop());
            this.videoStream = null;

            this.removeGlobalKeyboardListener();
        },

        async handleCodeSubmit(){
            const arr = await this.searchVouchers({ code: this.codeValue });

            if (arr.length) {
                this.currentVoucher = arr[0];
                this.switchToSecretMode();
            } else {
                this.errorMsg = 'Nenhum voucher encontrado com o código informado.';
            }
        },
        async searchVouchers(params){
            return await requestJson(this.voucherSearchUrl, params);
        },
        async handleConsumeClick(exceptional = false, secret = null, event = null) {
            if (this.saleHasOpenRefundRequest && !confirm("Há um estorno em processamento para esta venda. Tem certeza que deseja consumir o voucher? A ação é irreversível.")) {
                return;
            }

            if(exceptional && !confirm("Deseja consumir este voucher sem a senha? Você poderá registrar a senha posteriormente")){
                return;
            }

            await this.consumeVoucher(this.currentVoucher, secret, exceptional, event, false);
        },
        async handleConsumeAllClick(exceptional = false, secret = null) {
            if (this.saleHasOpenRefundRequest && !confirm("Há um estorno em processamento para esta venda. Tem certeza que deseja consumir os vouchers? A ação é irreversível.")) {
                return;
            }

            if(exceptional && !confirm("Deseja consumir este voucher sem a senha? (Você poderá registrar a senha posteriormente)")){
                return;
            }

            const otherCount = this.currentVoucher.reservation_info.other_consumable_count;
            if (!confirm(`Deseja consumir todos os ${otherCount + 1} vouchers pendentes da reserva?`)) {
                return;
            }

            await this.consumeVoucher(this.currentVoucher, secret, exceptional, null, true);
        },
        async consumeVoucher(voucher, secret, exceptionally = false, event = null, consumeAll = false){
            const body = { code: voucher.code };

            body.exceptional_consumption = exceptionally;
            body.consume_all = consumeAll;

            if(secret) {
                body.secret = secret;
            }

            const json = await requestJson(voucher.consume_url, body, 'PATCH');

            if (json.status == 'ok') {
                const message = consumeAll && json.consumed_count > 1 
                    ? `${json.consumed_count} vouchers consumidos com sucesso!`
                    : 'Voucher consumido com sucesso!';
                this.switchToResultMode(true, message, event);
            } else {
                let errors = [];
                if(json.error) {
                    this.switchToResultMode(false, json.error, event);
                } else {
                    $.each(json, (key, value) => errors.push(value[0]));
                    this.switchToResultMode(false, errors[0], event);
                }
            }
        },
        voucherCanBeConsumed(voucher) {
            return voucher !== null && !!voucher.consume_url;
        },
    }
}
</script>

<style lang="scss">
.error-message {
    display: block;
    margin-bottom: 1rem;
    color: #ea4335;
}
.check-circle .material-icons {
    font-size: 64px;

    &.check_circle {
        color: #34a853;
    }

    &.cancel {
        color: #ea4335;
    }
}
.video-display {
    max-width: 100%;
}
</style>
